import { FlexWorkersFilters } from '@types';

export const DEFAULT_LEVEL_FILTER: FlexWorkersFilters['level'] = 'ALL';
